export default __webpack_public_path__ + "assets/payment-icons/jcb.b84ffd11330f17c1fc05215d1359bbb1.svg";